import { Box, Link, Typography } from "@mui/material";
import ManulifeLogo from "../../assets/images/manulife.svg";
import "./style.scss";
import { useEffect, useState } from "react";
import SubBody from "./SubBody";

type ItemMenuType = {
  label: string;
  href: string;
};

type SubMenuType = {
  menus: ItemMenuType[];
  isOpen: boolean;
  onMouseOut: any;
};

export default function SubMenu({ menus, isOpen, onMouseOut }: SubMenuType) {
  const onOpenSubMenu = (isopen: boolean) => {
    const elmSubMenu = document.getElementById("sub-menu");
    const elmPage = document.getElementById("content-page");
    if (!elmSubMenu || !elmPage) return;
    if (!isopen) {
      elmSubMenu.style.opacity = "0";
      elmSubMenu.style.width = "0px";
      elmSubMenu.style.zIndex = "-1";
      elmPage.style.paddingLeft = "0px";
    } else {
      elmSubMenu.style.width = "340px";
      elmSubMenu.style.opacity = "1";
      elmSubMenu.style.zIndex = "9999";
      elmPage.style.paddingLeft = "340px";
    }
    elmSubMenu.style.transition = ".3s";
    elmPage.style.transition = ".3s";
  };

  const handleClickSubMenu = (item: any) => {
    console.log("SUB MENU:", item);
    onMouseOut();
  };

  useEffect(() => {
    onOpenSubMenu(isOpen);
  }, [isOpen]);

  return (
    <Box
      onMouseLeave={() => {
        onMouseOut();
      }}
      id="sub-menu"
    >
      <Box>
        <div className="img-logo">
          <img src={ManulifeLogo} alt="Manulife Logo" />
        </div>
      </Box>{" "}
      <SubBody
        menus={menus}
        onClickSub={(e: any) => {
          handleClickSubMenu(e);
        }}
      />
    </Box>
  );
}
